/* The connectors between chapters. A path is drawn from the state of its two
   ends: done when the target is finished, open when the source is, locked
   otherwise — and the one edge leading to the next open chapter is marked. */
import { ALL_EDGES, byId, chapterDone, firstOpen } from '../../engine/progress';
import { WORLD, edgePath } from '../../engine/graph';
import { useApp } from '../../state/AppProvider';

export function EdgeLayer() {
  const { progress, ignite } = useApp();
  const next = firstOpen(progress);

  return (
    <svg
      className="edges"
      id="edges"
      aria-hidden="true"
      width={WORLD.w}
      height={WORLD.h}
      viewBox={`0 0 ${WORLD.w} ${WORLD.h}`}
    >
      {ALL_EDGES.map(([from, to]) => {
        const a = byId(from);
        const b = byId(to);
        if (!a || !b) return null;
        const state = chapterDone(b, progress) ? 'done' : chapterDone(a, progress) ? 'open' : 'locked';
        return (
          <path
            key={`${from}->${to}`}
            data-state={state}
            data-extra={a.extra || b.extra ? 'true' : 'false'}
            data-next={next && b.id === next.id && state === 'open' ? 'true' : undefined}
            data-ignite={ignite && (a.id === ignite || b.id === ignite) ? 'true' : undefined}
            d={edgePath(a, b)}
          />
        );
      })}
    </svg>
  );
}
